module.exports = __webpack_public_path__ + "static/img/brees-2016-slide-4.ce82643.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2016-slide-4.jpg
// module id = lREs
// module chunks = 1